import axios from "@/api/axiosInstance";
import { GetCourseResponse } from "./types";

export const getCourse = async (uuid: string): Promise<GetCourseResponse> => {
  const response = await axios.get<GetCourseResponse>(
    `/api/private/learning-center/courses/${uuid}`,
  );
  return response.data;
};
